import { render, staticRenderFns } from "./MediaAudioStreams.vue?vue&type=template&id=12001b86&"
import script from "./MediaAudioStreams.vue?vue&type=script&lang=js&"
export * from "./MediaAudioStreams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports